/**
 * Weirwood
 * Copyright 2020 Baidu Inc. All rights reserved.
 *
 * @file 监控资源加载异常脚本
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */

export interface ResourceError {
    type: string;
    asset: string;
    integrity: any;
    element: string;
    path: string;
    page: string;
}

const MAX_URL_LENGTH = 255;

function getResourcePath(e: Event) {
    const paths = (e as any).path || [];
    let path = '';
    for (let i = 0; i < paths.length; i++) {
        const currentEl = paths[i];
        if (currentEl === window) {
            path += 'Window';
            continue;
        }
        path += currentEl.nodeName;
        path += currentEl.id ? '#' + currentEl.id : '';
        path += currentEl.className ? '.' + currentEl.className.split(' ').join('.') : '';
        if (i < paths.length) {
            path += ' > ';
        }
    }
    return path;
}

function getPath(url: string) {
    return (url || '').replace(/#.*$/, '').replace(/\?.*$/, '');
}

export function installResourceLoadErrorsHandler(cb?: Function) {
    window.addEventListener('error', (e: Event) => {
        if (!e || !e.target) { return; }
        if (e.target === window) {
            return;
        }

        const el = e.target as HTMLElement;
        const tagName = el?.tagName ?? 'unknown tagname';

        // 如果是资源加载异常
        if (['SCRIPT', 'LINK', 'IMG'].indexOf(tagName) !== -1) {
            const sourceUrl = (el as HTMLScriptElement).src || (el as HTMLLinkElement).href;
            const href = window.location.href;
            const path = getResourcePath(e);
            const resourceErrorObj = {
                type: tagName,
                asset: getPath(sourceUrl) === getPath(href) ? '空资源' : sourceUrl,
                // Integrity metadata used in Subresource Integrity checks
                // Security Feature that allows browsers to verify what they fetch.
                // Only available on <script> and <link>
                // see https://www.w3.org/TR/SRI/#resource-integrity
                integrity: (el as HTMLScriptElement).integrity,
                element: el && el.outerHTML && el.outerHTML.replace(/"/g, ''),
                path: path.replace(/"/g, ''),
                page: window.location.href.slice(0, MAX_URL_LENGTH)
            };
            cb && cb(resourceErrorObj);
        }
    }, true);
}
